module.exports = __webpack_public_path__ + "assets/web-vitals.43b03d2e.svg";